<template>
  <v-container fluid grid-list-md class="page-body d-flex flex-column" :class="{'pa-2': $vuetify.breakpoint.smAndDown, 'pa-10': $vuetify.breakpoint.mdAndUp}">
    <v-layout row class="clock-search-row"> 
      <v-flex xs12 sm6>
        <clock />
      </v-flex>
      <v-flex xs12 sm6>
        <search />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 class="weather-widget mt-2">
        <weather />
      </v-flex>
    </v-layout>
    <v-layout row class="index-bookmarks align-end">
      <v-flex xs12>
        <bookmarkcards :bookmarks="indexBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
    </v-layout>
  </v-container>


</template>

<script>
import dataApi from '../services/ApiService'

export default {
  name: 'Index',
  data: () => ({
      loading: false,
      is_data_fetched: false,
      indexBookmarks: []
  }),
  methods: {
    getDataFile() {
      dataApi.fetchDataFile ('index-bookmarks.json')
      .then(response => {
        if (Object.keys(response).length) {
          this.indexBookmarks = response.bookmarkList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

    }
  },
  mounted () {
    this.getDataFile()
  }
}
</script>

<style lang="scss" scoped>
  .page-body {
    height: 100vh;
  }

  .clock-search-row {
    flex: 0 0 auto;
  }

</style>

<style lang="scss">
  .bookmark-card-container {
    max-width: 1000px !important;
  }

  .index-bookmarks {
    .section-header {
      display: none;
    }
  }
</style>